import {
  PackageCategoryResponse,
  CreatePackageCategoryFormType,
  CreatePackageCategoryResponse,
  DeletePackageCategoryRequestBody,
  DeletePackageCategoryResponse,
  EditPackageCategoryFormType,
  EditPackageCategoryResponse,
  CreatePackageSubCategoryFormType,
  CreatePackageSubCategoryResponse,
  EditPackageSubCategoryFormType,
  EditPackageSubCategoryResponse,
  DeletePackageSubCategoryRequestBody,
  DeletePackageSubCategoryResponse,
} from "src/pages/MasterData/PackageCategory/api/interfaces";
import API from ".";

const featureApiRoute = "/package-categories";
const subFeatureApiRoute = "/package-sub-categories";

export const getPackageCategory =
  async (): Promise<PackageCategoryResponse> => {
    const response = await API.get<PackageCategoryResponse>(featureApiRoute);

    return response.data;
  };

export const createPackageCategory = async (
  form: CreatePackageCategoryFormType
): Promise<CreatePackageCategoryResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.post<CreatePackageCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editPackageCategory = async ({
  id,
  ...form
}: EditPackageCategoryFormType): Promise<EditPackageCategoryResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.put<EditPackageCategoryResponse>(
    `${featureApiRoute}/${id}`,
    requestBody
  );

  return response.data;
};

export const deletePackageCategory = async ({
  id,
}: DeletePackageCategoryRequestBody): Promise<DeletePackageCategoryResponse> => {
  const response = await API.delete<DeletePackageCategoryResponse>(
    `${featureApiRoute}/${id}`
  );

  return response.data;
};

export const createPackageSubCategory = async (
  form: CreatePackageSubCategoryFormType
): Promise<CreatePackageSubCategoryResponse> => {
  const requestBody = {
    package_category_id: form.packageCategoryId,
    name: form.name,
    hex: form.color,
  };

  const response = await API.post<CreatePackageSubCategoryResponse>(
    subFeatureApiRoute,
    requestBody
  );

  return response.data;
};

export const editPackageSubCategory = async ({
  id,
  ...form
}: EditPackageSubCategoryFormType): Promise<EditPackageSubCategoryResponse> => {
  const requestBody = {
    package_category_id: form.packageCategoryId,
    name: form.name,
    hex: form.color,
  };

  const response = await API.put<EditPackageSubCategoryResponse>(
    `${subFeatureApiRoute}/${id}`,
    requestBody
  );

  return response.data;
};

export const deletePackageSubCategory = async ({
  id,
}: DeletePackageSubCategoryRequestBody): Promise<DeletePackageSubCategoryResponse> => {
  const response = await API.delete<DeletePackageSubCategoryResponse>(
    `${subFeatureApiRoute}/${id}`
  );

  return response.data;
};
